module.exports = {
    FBID: '342277072919604',
    LANGUAGE: 'zh_TW'
}


// WEBPACK FOOTER //
// ./server/lib/config.js